import React from "react";
import requestEsriModules from "@mrwa/rime-replacement/infrastructure/esriModules";

import "./baseMapSelector.css";

export default class BaseMapSelector extends React.PureComponent {
  static componentName = "tripleBasemapSelector";

  constructor(props) {
    if (!props.basemaps || props.basemaps.length !== 3)
      throw new Error("Triple BaseMap Selector requires three basemaps");

    super(props);

    this.state = { active: "one" };

    this.selectOne = this.selectItem.bind(this, "one");
    this.selectTwo = this.selectItem.bind(this, "two");
    this.selectThree = this.selectItem.bind(this, "three");
  }

  async componentDidMount() {
    const { Basemap } = await requestEsriModules({
      Basemap: "esri/Basemap",
    });

    const mapOne = Basemap.fromId(this.props.basemaps[0].name);
    const mapTwo = Basemap.fromId(this.props.basemaps[1].name);
    const mapThree = Basemap.fromId(this.props.basemaps[2].name);

    this.setState({ mapOne, mapTwo, mapThree });
  }

  selectItem(basemap) {
    switch (basemap) {
      case "one":
        this.props.view.map.basemap = this.state.mapOne;
        break;
      case "two":
        this.props.view.map.basemap = this.state.mapTwo;
        break;
      case "three":
        this.props.view.map.basemap = this.state.mapThree;
        break;
      default:
        throw new Error("unknown basemap");
    }

    this.setState({ active: basemap });
  }

  render() {
    return (
      <div className={`tripleBasemapSelector ${this.state.active}Active`}>
        <div
          className="esri-component one"
          title={this.props.basemaps[0].title}
          onClick={this.selectOne}
          style={
            this.state.mapOne && {
              backgroundImage: `url('${this.state.mapOne.thumbnailUrl}')`,
            }
          }
        ></div>
        <div
          className="esri-component two"
          title={this.props.basemaps[1].title}
          onClick={this.selectTwo}
          style={
            this.state.mapTwo && {
              backgroundImage: `url('${this.state.mapTwo.thumbnailUrl}')`,
            }
          }
        ></div>
        <div
          className="esri-component three"
          title={this.props.basemaps[2].title}
          onClick={this.selectThree}
          style={
            this.state.mapThree && {
              backgroundImage: `url('${this.state.mapThree.thumbnailUrl}')`,
            }
          }
        ></div>
      </div>
    );
  }
}
